import React, { useState } from 'react';

function Popup({ isOpen, onClose, etazoLogin, item, time, isError, onChange, assesssmentCodeval }) {

  if (!isOpen) return null;  // Don't render if popup is not open

  return (
    <div className="popup-overlay">
      <div className="popup-content">
        <div>
          <div style={{ display: "inline-flex", alignItems: "center" }}>
            <p style={{ fontWeight: "bold" }} translate="no">
              {item.ID_Language === 0
                ? "Please enter the Assessment ID for auto-login :"
                : "Ingrese el ID de evaluación para iniciar sesión automáticamente :"}
            </p>
            <input
              type='text'
              className='assessmentCode'
              placeholder={item.ID_Language === 0 ?'Assessment ID' : 'ID de evaluación'}
              value={assesssmentCodeval}
              onChange={onChange} translate="no"
            />
          </div>
  
          {isError && (
            <p style={{ color: "red" }} translate="no">
              {item.ID_Language === 0
                ? "Please enter valid Assessment ID"
                : "Ingrese un ID de evaluación válido"}
            </p>
          )}
  
          {!time && (
            <p style={{ color: "red" }} translate="no">
              {item.ID_Language === 0 
                ? "You are attempting to access Etazo outside of restricted hours. Please try again during the authorized time frame."
                : "Intenta acceder a Etazo fuera del horario restringido. Inténtelo de nuevo durante el horario autorizado."}
            </p>
          )}
  
          <div>
            <button className='button-3' onClick={onClose}>
              {item.ID_Language === 0 ? "Cancel" : "Cancelar"}
            </button>
            <button className='button-3' onClick={() => etazoLogin(item)}>
              {item.ID_Language === 0 ? "GO" : "IR"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Popup;
